import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCSearchHondentaalLichaamstaalPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5084">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5085">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5086">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5087">
              <XIcon className="w-6 h-6" data-id="element-5088" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5089">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-gsearch_cmp-mcc_pt-optin-hondentaal-lichaamstaal" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5090"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5091">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5092">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5093" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5094">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5095">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5096">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5097" />
          <div className="hidden md:block" data-id="element-5098">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5099">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5100">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5101">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5102">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5103">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5104">
        <div className="md:col-span-7" data-id="element-5105">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-5106">
            Gratis Online Webinar: Honden-Lichaamstaal
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5107">
            Leer honden-lichaamstaal lezen - zodat je écht weet wat je hond
            bedoelt
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5108">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5109">
            <div className="flex -space-x-3" data-id="element-5110">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5111" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5112" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5113" />
            </div>
            <div data-id="element-5114">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5115">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5116">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5117">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om de hondentaal en
            lichaamstaal van hun hond te leren begrijpen - zodat ze direct zien
            wat hun hond denkt, voelt en nodig heeft.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5118">
            {['Waarom honden voor 95% met hun lichaam communiceren - en hoe je leert "luisteren met je ogen"', 'De belangrijkste kalmerings- en stresssignalen die elke hond gebruikt (en die de meeste baasjes missen)', 'Wat de stand van oren, staart, ogen, mond en lichaamshouding echt betekent', 'Hoe je subtiele signalen herkent vóórdat ze uitgroeien tot blaffen, uitvallen of angst', 'Hoe je de wereld leert zien vanuit je hond - zodat "onverklaarbaar gedrag" ineens logisch wordt', "Hoe je met je eigen lichaamstaal duidelijk maakt wat je wilt - zonder commando's of correcties"].map((item, i) => <li key={i} className="flex items-start" data-id="element-5119">
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5120" />
                <span className="text-gray-700 font-medium" data-id="element-5121">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5122">
            <div className="flex -space-x-3" data-id="element-5123">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5124" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5125" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5126" />
            </div>
            <div data-id="element-5127">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5128">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5129">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5130">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5131">
            <div className="flex justify-center items-center w-full" data-id="element-5132">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-gsearch_cmp-mcc_pt-optin-hondentaal-lichaamstaal" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5133"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5134">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5135">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5136">
            Leer honden-lichaamstaal lezen in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5137">
            <div className="flex flex-col items-center" data-id="element-5138">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5139" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5140">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5141">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5142">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5143" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5144">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5145">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5146">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5147" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5148">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5149">
                Leer in 90 minuten hoe je de honden-lichaamstaal van je hond
                leest en begrijpt
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5150">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5151">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5152">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5153">
            Duizenden baasjes leerden inmiddels de taal van hun hond lezen - en
            zeggen allemaal hetzelfde: <br data-id="element-5154" />
            <span className="italic" data-id="element-5155">
              "Ik zie nu pas wat mijn hond al die tijd probeerde te vertellen."
            </span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5156">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5157">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5158">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5159"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5160">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5161">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5162"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5163">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5164">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5165"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5166">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5167">
              <div className="flex items-center mb-4" data-id="element-5168">
                <div className="flex text-green-500 mr-2" data-id="element-5169">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5170" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5171">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5172">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5173">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5174">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5175">
              <div className="flex items-center mb-4" data-id="element-5176">
                <div className="flex text-green-500 mr-2" data-id="element-5177">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5178" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5179">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5180">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5181">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5182">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5183">
              <div className="flex items-center mb-4" data-id="element-5184">
                <div className="flex text-green-500 mr-2" data-id="element-5185">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5186" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5187">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5188">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5189">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5190">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5191">
              <div className="flex items-center mb-4" data-id="element-5192">
                <div className="flex text-green-500 mr-2" data-id="element-5193">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5194" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5195">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5196">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5197">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5198">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5199">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5200">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5201">
          <div data-id="element-5202">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5203">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5204">
              <p data-id="element-5205">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. En ik weet hoe het voelt als je het gevoel
                hebt dat je hond je iets probeert te vertellen - maar dat je
                niet weet wat.
              </p>
              <p data-id="element-5206">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes
                geleerd hoe ze de honden-lichaamstaal van hun hond kunnen lezen.
                Want zodra je die taal begrijpt, valt er een wereld voor je
                open: je ziet wanneer je hond zich onzeker voelt, wanneer hij
                speels is, wanneer hij stress opbouwt, en wanneer hij iets nodig
                heeft van jou.
              </p>
              <p data-id="element-5207">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                tussen baasjes en honden niet ontstaat door een 'slecht' hond of
                een 'falende' baas. Ze ontstaat doordat we letterlijk twee
                verschillende talen spreken. Honden communiceren voor 95% met
                hun lichaam - oren, staart, ogen, houding, ademhaling - terwijl
                wij vooral met onze stem praten. Geen wonder dat we elkaar vaak
                misverstaan.
              </p>
              <p data-id="element-5208">
                Daarom leer ik baasjes geen commando's of trucjes, maar iets
                veel waardevollers: hoe je hondentaal leest, hoe je je eigen
                lichaamstaal bewust inzet, en hoe je een gesprek voert in plaats
                van bevelen geeft. Geen dwang, geen straf, geen correcties.
                Alleen liefdevolle, echte communicatie.
              </p>
              <p data-id="element-5209">
                Dit webinar is mijn manier om deze kennis met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te verstaan.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5210">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5211" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5212">
        <div className="max-w-md mx-auto px-4" data-id="element-5213">
          <div className="p-6 rounded-3xl w-full" data-id="element-5214">
            <div className="flex justify-center items-center" data-id="element-5215">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-gsearch_cmp-mcc_pt-optin-hondentaal-lichaamstaal" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5216"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5217">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5218">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5219" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5220">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5221">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5222">
            <p className="mb-2" data-id="element-5223">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5224">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5225" />
    </div>;
}